<template>
  <div id="app">
    <router-view v-if="$route.path === '/login' || $route.path === '/'" />
    <el-container v-else style="height: 100vh">
      <el-aside width="200px" class="app-aside">
        <div class="logo">华魏WMS</div>

        <div class="warehouse-select" v-if="warehouses.length">
          <el-select v-model="selectedWarehouseId" placeholder="请选择仓库" size="small" @change="onWarehouseChange">
            <el-option v-for="item in warehouses" :key="item.id" :label="item.code + ' - ' + item.name" :value="item.id" />
          </el-select>
        </div>

         <!-- 自定义导航菜单 -->
         <div class="custom-menu" style="flex: 1; overflow-y: auto;">

           <div v-for="item in menuTree" :key="item.id">
            <!-- 有子菜单的父菜单 -->
            <div
              v-if="item.children && item.children.length"
              class="menu-parent"
              :class="{ active: popupMenuId === item.id }"
              @mouseenter="showPopup($event, item)"
              @mouseleave="startHideTimer"
              @click="showPopup($event, item)"
            >
              <div class="menu-parent-content">
                <i v-if="item.icon" :class="item.icon"></i>
                <!-- 任务4：父菜单汇总红点（任务1 灰点：countType=gray 显示灰色） -->
                <el-badge :value="item.count" :max="99" :hidden="!item.count"
                  class="menu-badge-wrap" :class="item.countType === 'gray' ? 'badge-gray' : 'badge-red'">
                  <span>{{ item.name }}</span>
                </el-badge>
                <i class="el-icon-arrow-right menu-arrow"></i>
              </div>
            </div>

            <!-- 无子菜单的叶子菜单（直接跳转） -->
            <div
              v-else
              class="menu-leaf"
              :class="{ active: $route.path === item.path }"
              @click="$router.push(item.path)"
            >
              <div class="menu-leaf-content">
                <i v-if="item.icon" :class="item.icon"></i>
                <!-- 任务4：叶子菜单红点（任务1 灰点：countType=gray 显示灰色） -->
                <el-badge :value="item.count" :max="99" :hidden="!item.count"
                  class="menu-badge-wrap" :class="item.countType === 'gray' ? 'badge-gray' : 'badge-red'">
                  <span>{{ item.name }}</span>
                </el-badge>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部区域 -->
        <div style="margin-top: auto;">
          <!-- 任务1（灰点）：手动刷新红点/灰点 -->
          <div style="padding: 6px 20px 2px;">
            <el-button size="mini" icon="el-icon-refresh" style="width: 100%;" @click="refreshCounts">刷新</el-button>
          </div>
          <div class="factory-switch" v-if="factoryList.length">
            <el-select v-model="currentFactory" size="small" @change="onFactoryChange" placeholder="切换工厂">
              <el-option v-for="f in factoryList" :key="f" :label="f" :value="f"></el-option>
            </el-select>
          </div>
          <div class="user-info">
            <span>{{ username }}</span>
            <el-button type="text" @click="openProfile">个人中心</el-button>
            <el-button type="text" @click="logout">退出</el-button>
          </div>
        </div>
      </el-aside>

      <!-- 子菜单浮窗 -->
      <div
        v-if="popupMenuId"
        class="submenu-popup"
        :style="{ top: popupTop + 'px' }"
        @mouseenter="cancelHideTimer"
        @mouseleave="startHideTimer"
      >
        <div
          v-for="child in popupChildren"
          :key="child.id"
          class="submenu-item"
          :class="{ active: $route.path === child.path }"
          @click="goTo(child.path)"
        >
          <i v-if="child.icon" :class="child.icon"></i>
          <!-- 任务4：浮窗子项红点（任务1 灰点：countType=gray 显示灰色） -->
          <el-badge :value="child.count" :max="99" :hidden="!child.count"
            class="menu-badge-wrap" :class="child.countType === 'gray' ? 'badge-gray' : 'badge-red'">
            <span>{{ child.name }}</span>
          </el-badge>
        </div>
      </div>

      <el-main>
        <!-- 任务A2：不加任何缓存，每次页面切换重新加载（稳定第一；仓库切换由 :key 重建） -->
        <router-view :key="currentWarehouseId" />
      </el-main>
    </el-container>
    <Profile ref="profile" />
  </div>
</template>

<script>
import Profile from '@/views/user/Profile.vue'
import { switchFactory } from '@/api/auth'
import { getMenuTree } from '@/api/menu'
import { getTaskCount } from '@/api/task'
// 任务3：红/灰点映射公共模块（侧边栏与 workflow 功能地图共用）
import { countOfNode } from '@/utils/countBadge'
import { addDynamicRoutes, resetRouter, resetRouteState } from '@/router'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: { Profile },
  data() {
    let factories = []
    try { const raw = localStorage.getItem('factories'); if (raw) factories = JSON.parse(raw) }
    catch (e) { console.warn('解析 factories 失败，使用空数组', e) }
    return {
      username: localStorage.getItem('username') || '管理员',
      menuTree: [],
      menuTreeKey: 0,
      popupMenuId: null,
      popupTop: 0,
      popupChildren: [],
      hideTimer: null,
      factoryList: factories,
      currentFactory: localStorage.getItem('currentFactory') || ''
    }
  },
  computed: {
    ...mapGetters(['currentWarehouseId', 'warehouses']),
    selectedWarehouseId: { get() { return this.currentWarehouseId }, set(val) { this.$store.commit('SET_CURRENT_WAREHOUSE', val) } },

  },
  async created() {
    const token = localStorage.getItem('token')
    if (token) {
      await this.refreshMenuTree(); await this.fetchWarehouses()
      // 切换工厂后跳过 fetchErpType，信任 onFactoryChange 写入的 localStorage 值
      if (sessionStorage.getItem('factory_switched') === 'true') {
        sessionStorage.removeItem('factory_switched')
      } else {
        await this.$store.dispatch('fetchErpType')
        await this.$store.dispatch('fetchVenusEnabled') // 任务A：维纳斯件功能开关（登录/刷新拉取）
        // 任务1（灰点）：30 秒轮询 + 页面操作后强制刷新事件监听
        this.startGrayPolling()
      }
    }
    else { this.menuTree = []; this.menuTreeKey = Date.now() }
  },
  beforeDestroy() {
    this.stopGrayPolling()   // 任务1（灰点）：清理轮询与事件监听
  },
  watch: {
    '$route'() {
      let factories = []; try { const raw = localStorage.getItem('factories'); if (raw) factories = JSON.parse(raw) } catch (e) { console.warn(e) }
      this.factoryList = factories
      this.currentFactory = localStorage.getItem('currentFactory') || ''
      if (this.$route.path !== '/login' && this.$route.path !== '/') this.username = localStorage.getItem('username') || '管理员'
      // 任务1：路由切换刷新待办红点（操作完成后返回侧边栏立即更新；未登录不发请求）
      if (localStorage.getItem('token')) this.refreshCounts()
    }
  },
  methods: {
    ...mapActions(['fetchWarehouses', 'fetchErpType', 'fetchVenusEnabled']),
    showPopup(e, item) {
      this.cancelHideTimer()
      this.popupMenuId = item.id
      this.popupChildren = item.children || []
      this.$nextTick(() => {
        const rect = e.currentTarget.getBoundingClientRect()
        this.popupTop = rect.top
      })
    },
    startHideTimer() {
      this.cancelHideTimer()
      this.hideTimer = setTimeout(() => {
        this.popupMenuId = null
        this.popupChildren = []
      }, 200)
    },
    cancelHideTimer() {
      if (this.hideTimer) { clearTimeout(this.hideTimer); this.hideTimer = null }
    },
    goTo(path) {
      if (!path) return
      if (this.$route.path === path) {
        this.popupMenuId = null
        this.popupChildren = []
        return
      }
      this.popupMenuId = null
      this.popupChildren = []
      this.$router.push(path).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err
      })
    },
    async refreshMenuTree() {
      try {
        this.menuTree = []; this.menuTreeKey = Date.now()
        // 任务1：菜单树与待办计数并行拉取（红点数字 = 进入页面后实际单据数量，factory 过滤）
        const [menuTree, counts] = await Promise.all([getMenuTree(), getTaskCount()])
        this.fillCounts(menuTree, counts || {})
        this.menuTree = menuTree; this.menuTreeKey = Date.now()
        localStorage.setItem('menuTree', JSON.stringify(menuTree))
        resetRouter(); addDynamicRoutes(menuTree)
      } catch (err) { console.error('刷新菜单树失败', err) }
    },
    // 任务4：按菜单 code 递归填充待办计数（后序：先子后父）——
    // 任务1（灰点）：红点 RED_KEYS（approve/rejected）+ 灰点 GRAY_KEYS（未完成单据数量，按实际 active 菜单 code）；
    // 父菜单汇总子节点之和（红点父汇总红色——任务4 行为；灰点父汇总灰色）
    fillCounts(nodes, counts) {
      if (!Array.isArray(nodes)) return
      nodes.forEach(node => {
        // 先递归子节点（子节点 count 先填充，父节点再汇总）
        this.fillCounts(node.children, counts)
        if (node.children && node.children.length) {
          // 父菜单：汇总子节点红点数量之和（任务4 红点；任务1 灰点）
          node.count = node.children.reduce((sum, child) => sum + (child.count || 0), 0)
          // 任一子节点为红点则父菜单显示红色（当前无红灰混合父菜单，兜底逻辑）
          node.countType = node.children.some(c => c.countType === 'red') ? 'red' : 'gray'
        } else {
          // 叶子节点：红/灰点映射（任务3：公共模块 countBadge——与 workflow 功能地图共用，防止双份维护漂移）
          const badge = countOfNode(node.code, counts)
          node.count = badge.count
          node.countType = badge.type
        }
      })
    },
    // 任务1：路由切换后刷新计数（审批/处理/驳回操作后返回侧边栏立即更新）
    async refreshCounts() {
      if (!localStorage.getItem('token')) { this.stopGrayPolling(); return }   // 任务1(0910)：无 token 自停轮询（防漏清兜底）
      try {
        const counts = await getTaskCount() || {}
        this.fillCounts(this.menuTree, counts)
        this.menuTreeKey = Date.now()
      } catch (e) { /* 静默失败，不影响导航 */ }
    },
    // 任务1（灰点）：30 秒轮询（全量刷新——红点同步无害）+ 页面操作后强制刷新（wms-counts-refresh 事件）
    startGrayPolling() {
      if (this.grayTimer) clearInterval(this.grayTimer)
      this.grayTimer = setInterval(() => { this.refreshCounts() }, 30000)
      window.addEventListener('wms-counts-refresh', this.refreshCounts)
    },
    stopGrayPolling() {
      if (this.grayTimer) { clearInterval(this.grayTimer); this.grayTimer = null }
      window.removeEventListener('wms-counts-refresh', this.refreshCounts)
    },
    onWarehouseChange(newId) { this.$store.commit('SET_CURRENT_WAREHOUSE', newId) },
    async onFactoryChange(newFactory) {
      try {
        const res = await switchFactory({ factory: newFactory })
        localStorage.setItem('token', res.token); localStorage.setItem('currentFactory', newFactory)
        localStorage.setItem('erpType', res.erpType || 'NONE')
        localStorage.setItem('sysConnection', res.sysConnection || 'ONLY_WMS')   // A-1.2：连接模式
        this.$store.commit('SET_ERP_TYPE', res.erpType || 'NONE')
        this.$store.commit('SET_SYS_CONNECTION', res.sysConnection || 'ONLY_WMS')   // A-1.2
        // 任务A：维纳斯件功能开关（切换工厂后功能入口显隐）
        this.$store.commit('SET_VENUS_ENABLED', res.venusEnabled === false ? false : true)
        // 保存新工厂的权限（切换工厂后刷新按钮状态的关键）
        if (res.permissions) {
          localStorage.setItem('permissions', JSON.stringify(res.permissions))
          this.$store.commit('SET_PERMISSIONS', res.permissions)
        }
        if (res.roles) {
          localStorage.setItem('roles', JSON.stringify(res.roles))
          this.$store.commit('SET_ROLES', res.roles)
        }
        sessionStorage.setItem('factory_switched', 'true')
        window.location.reload()
      } catch (err) { this.$message.error(err.message || '切换失败') }
    },
    openProfile() { this.$refs.profile.open() },
    logout() {
      this.stopGrayPolling()            // 任务1(0910)：退出即停轮询与事件监听（原缺失——退出后 30s task/count 无 token 401 弹窗不停）
      localStorage.clear()
      resetRouteState()
      this.$router.push('/login')       // 任务1(0910)：原 push('/') 停留 Home 半壳页（公开页放行、根组件不销毁、轮询永续）
      this.$message.success('已退出登录')
    }
  }
}
</script>

<style>
body { margin: 0; background: #0b1a2a; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif; }

/* === 侧边栏整体 === */
.app-aside {
  background: linear-gradient(180deg, #0b1a2a 0%, #13243a 50%, #0f1f32 100%);
  display: flex;
  flex-direction: column;
  height: 100vh;
  box-shadow: 4px 0 32px rgba(0, 40, 80, 0.5), inset -1px 0 0 rgba(64, 158, 255, 0.08);
  z-index: 100;
  border-right: 1px solid rgba(64, 158, 255, 0.06);
}

/* === Logo === */
.logo {
  height: 68px;
  line-height: 68px;
  text-align: center;
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  background: linear-gradient(135deg, #061220 0%, #0f1f32 100%);
  flex-shrink: 0;
  letter-spacing: 3px;
  border-bottom: 1px solid rgba(64, 158, 255, 0.1);
  position: relative;
}
.logo::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 30%;
  right: 30%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #409EFF, transparent);
  opacity: 0.6;
}
.logo span {
  background: linear-gradient(135deg, #66b1ff, #409EFF, #1890ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 0 0 40px rgba(64, 158, 255, 0.15);
}

/* === 仓库选择器 === */
.warehouse-select {
  padding: 16px 20px 12px;
  background: transparent;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(64, 158, 255, 0.06);
}
.warehouse-select .el-select { width: 100%; }
.warehouse-select .el-input__inner {
  background: rgba(255, 255, 255, 0.04) !important;
  border-color: rgba(64, 158, 255, 0.15) !important;
  color: #a8c8e8 !important;
  border-radius: 8px;
  height: 36px;
  transition: all 0.3s ease;
}
.warehouse-select .el-input__inner:focus {
  border-color: #409EFF !important;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15), 0 0 20px rgba(64, 158, 255, 0.05);
}
.warehouse-select .el-input__inner::placeholder { color: rgba(168, 200, 232, 0.4); }

/* === 自定义菜单容器 === */
.custom-menu {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0 12px;
}
.custom-menu::-webkit-scrollbar { width: 3px; }
.custom-menu::-webkit-scrollbar-track { background: transparent; }
.custom-menu::-webkit-scrollbar-thumb {
  background: rgba(64, 158, 255, 0.25);
  border-radius: 4px;
}
.custom-menu::-webkit-scrollbar-thumb:hover { background: rgba(64, 158, 255, 0.5); }

/* ===== 父菜单（分组标题）===== */
.menu-parent {
  cursor: pointer;
  user-select: none;
  margin: 2px 12px;
  border-radius: 10px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}
.menu-parent.active {
  background: rgba(64, 158, 255, 0.1);
  box-shadow: 0 0 20px rgba(64, 158, 255, 0.04), inset 0 0 0 1px rgba(64, 158, 255, 0.08);
}
.menu-parent::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 0;
  background: linear-gradient(180deg, #409EFF, #66b1ff);
  border-radius: 0 4px 4px 0;
  transition: height 0.3s ease;
}
.menu-parent:hover::before,
.menu-parent.active::before { height: 60%; }
.menu-parent:hover {
  background: rgba(64, 158, 255, 0.06);
}
.menu-parent-content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 18px;
  height: 52px;
  line-height: 52px;
  color: rgba(168, 200, 232, 0.8);
  font-size: 15px;
  font-weight: 500;
  border-radius: 10px;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
}
.menu-parent-content i:first-child {
  font-size: 18px;
  width: 20px;
  color: rgba(100, 180, 255, 0.5);
  transition: all 0.3s ease;
}
.menu-parent:hover .menu-parent-content i:first-child {
  color: #66b1ff;
  text-shadow: 0 0 20px rgba(64, 158, 255, 0.3);
}
.menu-parent.active .menu-parent-content { color: #e8f0f8; }
.menu-parent.active .menu-parent-content i:first-child {
  color: #409EFF;
  text-shadow: 0 0 30px rgba(64, 158, 255, 0.4);
}
.menu-arrow {
  margin-left: auto;
  font-size: 12px;
  color: rgba(100, 180, 255, 0.3);
  transition: all 0.3s ease;
}
.menu-parent:hover .menu-arrow { color: #66b1ff; }

/* ===== 叶子菜单（直接跳转）===== */
.menu-leaf {
  cursor: pointer;
  user-select: none;
  margin: 2px 12px;
  border-radius: 10px;
  transition: all 0.25s ease;
  position: relative;
}
.menu-leaf::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 0;
  background: linear-gradient(180deg, #409EFF, #66b1ff);
  border-radius: 0 4px 4px 0;
  transition: height 0.3s ease;
}
.menu-leaf.active::before { height: 50%; }
.menu-leaf:hover { background: rgba(64, 158, 255, 0.06); }
.menu-leaf.active {
  background: rgba(64, 158, 255, 0.08);
  box-shadow: 0 0 20px rgba(64, 158, 255, 0.03);
}
.menu-leaf-content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 18px;
  height: 48px;
  line-height: 48px;
  color: rgba(168, 200, 232, 0.75);
  font-size: 14px;
  border-radius: 10px;
  transition: all 0.25s ease;
}
.menu-leaf-content i:first-child {
  font-size: 17px;
  width: 20px;
  color: rgba(100, 180, 255, 0.4);
  transition: all 0.3s ease;
}
.menu-leaf:hover .menu-leaf-content i:first-child {
  color: #66b1ff;
  text-shadow: 0 0 20px rgba(64, 158, 255, 0.2);
}
.menu-leaf.active .menu-leaf-content {
  color: #66b1ff;
  font-weight: 500;
}
.menu-leaf.active .menu-leaf-content i:first-child {
  color: #409EFF;
  text-shadow: 0 0 30px rgba(64, 158, 255, 0.3);
}

/* ===== 子菜单浮窗 ===== */
.submenu-popup {
  position: fixed;
  left: 210px;
  background: linear-gradient(145deg, #0d1f33 0%, #0b1a2a 100%);
  border-radius: 12px;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(64, 158, 255, 0.08), 0 0 40px rgba(64, 158, 255, 0.03);
  padding: 8px 0;
  width: 220px;
  z-index: 2000;
  min-height: 50px;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(64, 158, 255, 0.06);
}
.submenu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 20px;
  font-size: 14px;
  color: rgba(168, 200, 232, 0.8);
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;
  border-left: 2px solid transparent;
}
.submenu-item i:first-child {
  font-size: 16px;
  width: 18px;
  color: rgba(100, 180, 255, 0.35);
  transition: all 0.25s ease;
}
.submenu-item:hover {
  background: rgba(64, 158, 255, 0.08);
  color: #66b1ff;
  border-left-color: #409EFF;
}
.submenu-item:hover i:first-child {
  color: #66b1ff;
  text-shadow: 0 0 20px rgba(64, 158, 255, 0.2);
}
.submenu-item.active {
  color: #66b1ff;
  font-weight: 500;
  background: rgba(64, 158, 255, 0.06);
  border-left-color: #409EFF;
}
.submenu-item.active i:first-child {
  color: #409EFF;
  text-shadow: 0 0 30px rgba(64, 158, 255, 0.3);
}

/* ===== 工厂切换 ===== */
.factory-switch {
  padding: 14px 20px 10px;
  background: transparent;
  border-top: 1px solid rgba(64, 158, 255, 0.06);
  flex-shrink: 0;
}
.factory-switch .el-select { width: 100%; }
.factory-switch .el-input__inner {
  background: rgba(255, 255, 255, 0.03) !important;
  border-color: rgba(64, 158, 255, 0.1) !important;
  color: #a8c8e8 !important;
  border-radius: 8px;
  height: 34px;
  transition: all 0.3s ease;
}
.factory-switch .el-input__inner:focus {
  border-color: #409EFF !important;
  box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
}
.factory-switch .el-select-dropdown {
  background: #0d1f33 !important;
  border: 1px solid rgba(64, 158, 255, 0.1) !important;
}
.factory-switch .el-select-dropdown__item {
  color: #a8c8e8 !important;
}
.factory-switch .el-select-dropdown__item.hover,
.factory-switch .el-select-dropdown__item:hover {
  background: rgba(64, 158, 255, 0.1) !important;
  color: #66b1ff !important;
}

/* ===== 用户信息 ===== */
.user-info {
  padding: 14px 20px 16px;
  background: transparent;
  border-top: 1px solid rgba(64, 158, 255, 0.06);
  color: #bfcbd9;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}
.user-info span {
  color: rgba(168, 200, 232, 0.7);
  font-weight: 400;
  font-size: 13px;
}
.user-info .el-button--text {
  color: rgba(100, 180, 255, 0.5);
  padding: 0 6px;
  font-size: 13px;
  transition: all 0.3s ease;
}
.user-info .el-button--text:hover {
  color: #66b1ff;
  text-shadow: 0 0 20px rgba(64, 158, 255, 0.15);
}

/* ===== 响应式适配 ===== */
@media (max-width: 768px) {
  .app-aside { width: 180px !important; }
  .submenu-popup { left: 190px; width: 190px; }
}

/* 任务4：待办红点徽标（el-badge）——样式置于 style 块内（任务1 误加在 style 结束标签之外，从未生效） */
.menu-badge-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.menu-badge-wrap .el-badge__content {
  background-color: #F56C6C;
}
/* 任务1（灰点）：灰点徽标（未完成单据数量；红点 #F56C6C 既有） */
.menu-badge-wrap.badge-gray .el-badge__content {
  background-color: #909399;
  font-size: 12px;
  height: 18px;
  line-height: 18px;
  padding: 0 6px;
  border: none;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(245, 108, 108, 0.4);
  transform: translate(50%, -45%);   /* 任务4：微调——避开 flex 行高居中偏差 */
}
</style>

